module.exports = __webpack_public_path__ + "img/spiegel_pauschalreisen_banner.jpg";